// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.laser {
  display: flex;
  flex-direction: row;
  position: relative;
  filter: blur(100px);
  position: relative;
  animation: blurry 2s ease-in-out forwards;
  gap: 1em;
  font-family: "Varela Round";
  padding: 0;
  z-index: 1;
  transform: translate3d(0, 0, 0.1px);
}
.laser_title {
  font-family: "Varela Round";
  color: white;
  padding: 0 3em;
  margin: 0;
}
.laser_artist {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5em;
  padding: 0 0.2em;
  animation: fadeIn 0.3s ease-in-out forwards;
  transition: all 10s cubic-bezier(0.77, 0, 0.175, 1);
}
.laser_artist_choose {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.laser_videos {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 3em;
  padding: 0 0.2em;
  gap: 2em;
}
.laser_videos > video {
  width: 40em;
  height: 30em;
}
.laser_testimony {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 1em;
  padding: 0 0.2em;
  gap: 2em;
}
.laser_testimony > video {
  width: 30em;
  height: 30em;
}
.laser_process {
  height: 40em;
  overflow-y: scroll;
  color: white;
  padding: 1em;
  margin-top: 8em;
  animation: fadeIn 0.3s ease-in-out forwards;
  transition: all 10s cubic-bezier(0.77, 0, 0.175, 1);
}
.laser_process > h1 {
  color: #ffc917;
}
.laser_process_content {
  font-family: "Varela Round";
  line-height: 2em;
  font-size: 1.4em;
  width: 80%;
  color: #f3f3f3;
}
.laser_process_steps > ol {
  line-height: 2em;
  font-size: 1.4em;
  color: #88888a;
}
.laser_process_steps > p {
  line-height: 2em;
  font-size: 1.4em;
  color: #f3f3f3;
}
.laser_process_technology {
  line-height: 2em;
  font-size: 1.4em;
  color: #88888a;
}
.laser_process_faq {
  line-height: 2em;
  font-size: 1.4em;
  color: #f3f3f3;
}

.overlay-laser-menu {
  display: flex;
  flex-direction: column;
  gap: 2em;
  width: 25%;
  height: 50em;
  opacity: 1;
  position: relative;
  background-image: linear-gradient(to top, #050505, #1f1f1f, #353536, #4c4c4e, #656567, #656567, #656567, #656567, #4c4c4e, #353536, #1f1f1f, #050505);
  z-index: 5;
}
.overlay-laser-menu_title {
  margin-top: 10em;
}
.overlay-laser-menu_subtitle {
  font-family: "Varela Round";
  font-size: 11px;
  letter-spacing: 5px;
  line-height: 2em;
  color: white;
  text-transform: uppercase;
  position: relative;
  padding: 1em 4em;
}
.overlay-laser-menu_shirts {
  cursor: pointer;
  position: relative;
  top: 20%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(136, 136, 138);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-laser-menu_shirts_img {
  width: 4em;
  height: 4em;
}
.overlay-laser-menu_shirts_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-laser-menu_shirts_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-laser-menu_shirts_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-laser-menu_shirts:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-laser-menu_shirts:hover_title_top {
  color: black;
}
.overlay-laser-menu_tattoo-care {
  cursor: pointer;
  position: relative;
  top: 22%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(136, 136, 138);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-laser-menu_tattoo-care_img {
  width: 4em;
  height: 4em;
}
.overlay-laser-menu_tattoo-care_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-laser-menu_tattoo-care_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-laser-menu_tattoo-care_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-laser-menu_tattoo-care:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-laser-menu_tattoo-care:hover_title_top {
  color: black;
}
.overlay-laser-menu_jewelry {
  cursor: pointer;
  position: relative;
  top: 24%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(136, 136, 138);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-laser-menu_jewelry_img {
  width: 4em;
  height: 4em;
  border-radius: 4px;
  overflow: hidden;
}
.overlay-laser-menu_jewelry_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-laser-menu_jewelry_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-laser-menu_jewelry_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-laser-menu_jewelry:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-laser-menu_jewelry:hover_title_top {
  color: black;
}

img {
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
  image-rendering: auto;
}

@keyframes blurry {
  0% {
    filter: blur(100px);
  }
  100% {
    filter: blur(0px);
  }
}
@keyframes flickerL {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  100% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
}
@keyframes flickerO {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.66667% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  73.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  74% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  74.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  75.33333% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  75.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  94.44444% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
@keyframes flickerA {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.86667% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.88889% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerD {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.31111% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerI {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.75556% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerN {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.2% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerG {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.64444% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
#l-mobile li, #r-mobile li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.4vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: #f3f3f3;
}

#l {
  position: absolute;
  top: 20%;
  left: 0%;
  height: 5vw;
  width: 40%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#l li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#l li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#l li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#l li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#l li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#l li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#l li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 1.25s;
  animation-duration: 4.5s;
}

#l li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#l li:nth-child(8) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#l li:nth-child(9) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#l li:nth-child(10) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#r {
  position: absolute;
  top: 20%;
  left: 30%;
  height: 5vw;
  width: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#r li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#r li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#r li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#r li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#r li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#r li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#r li:nth-child(6) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#r li:nth-child(7) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#r li:nth-child(8) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#r li:nth-child(9) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

.card--laser1 .card__img,
.card--laser1 .card__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/removal-1.png");
}

.card--laser2 .card__img,
.card--laser2 .card__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/removal-2.png");
}

.card--laser3 .card__img,
.card--laser3 .card__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/removal-3.png");
}

.card--1 .card__img,
.card--1 .card__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/q-artist.png");
}

.card--2 .card__img,
.card--2 .card__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/krissy-artist.png");
}

.card--3 .card__img,
.card--3 .card__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/miriam.png");
}

.card__like {
  width: 18px;
}

.card__clock {
  width: 15px;
  vertical-align: middle;
  fill: #ad7d52;
}

.card__time {
  font-size: 12px;
  color: #ad7d52;
  vertical-align: middle;
  margin-left: 5px;
}

.card__clock-info {
  float: right;
}

.card__img {
  visibility: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 235px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.card__info-hover {
  position: absolute;
  padding: 16px;
  width: 100%;
  opacity: 0;
  top: 0;
}

.card__img--hover {
  transition: 0.2s all ease-out;
  background-size: cover;
  background-repeat: no-repeat;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  width: 100%;
  position: absolute;
  height: 20em;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  top: 0;
}

.card {
  margin-right: 25px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0, 1);
  background-color: #050505;
  width: 25em;
  height: 30em;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
}

.card:hover {
  box-shadow: 0px 30px 18px -8px rgba(0, 0, 0, 0.1);
  transform: scale(1.1, 1.1);
  border: 1px solid white;
}

.card__info {
  z-index: 2;
  background-color: #f3f3f3;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 7em 1em;
}

.card__category {
  display: inline-block;
  font-family: "Varela Round";
  font-size: 11px;
  letter-spacing: 5px;
  color: #88888a;
  text-transform: uppercase;
  position: relative;
}

.card__title {
  margin-top: 5px;
  margin-bottom: 10px;
  font-family: "Varela Round";
  color: #050505;
  text-transform: uppercase;
  position: relative;
}

.card__by {
  font-size: 12px;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
}

.card__author {
  font-weight: 600;
  text-decoration: none;
  color: #ad7d52;
}

.card:hover .card__img--hover {
  height: 100%;
}

.card:hover .card__info {
  background-color: transparent;
  position: relative;
}

.card:hover .card__info-hover {
  opacity: 1;
}

@media (min-width: 390px) {
  .laser {
    flex-wrap: wrap;
    height: auto;
  }
  .laser_artist {
    gap: 5em;
    flex-wrap: wrap;
  }
  .laser_artist_choose {
    flex-wrap: wrap;
  }
  .laser_artist article {
    z-index: 4;
  }
  .laser_process {
    padding: 2em;
  }
  .laser_videos {
    flex-direction: column;
  }
  .laser_videos > video {
    width: 30em;
    height: 30em;
  }
  .laser_testimony {
    flex-direction: column;
  }
  .laser_testimony > video {
    width: 30em;
    height: 30em;
  }
  .overlay-laser-menu {
    width: 100%;
    height: 30em;
  }
  #l li,
  #r li {
    font-size: 1.2em !important;
  }
  #l-mobile li {
    font-size: 1.8em !important;
  }
  .card {
    width: 20em;
  }
  .laser_artist_choose {
    gap: 5em;
  }
}
@media (min-width: 768px) {
  .laser {
    flex-wrap: nowrap;
    height: auto;
    justify-content: baseline;
  }
  .laser_artist {
    gap: 0em;
    margin-top: 8em;
    flex-direction: row;
    padding: 0;
    margin: 0;
  }
  .laser_process {
    padding: 1em;
    font-size: 0.8em;
  }
  .laser_videos {
    flex-direction: column;
  }
  .laser_videos > video {
    width: 30em;
    height: 30em;
  }
  .laser_testimony {
    flex-direction: column;
  }
  .laser_testimony > video {
    width: 30em;
    height: 30em;
  }
  .card--laser1,
  .card--laser2,
  .card--laser3 {
    width: 20em;
    height: 20em;
  }
  .overlay-piercing-menu {
    width: 50%;
  }
  #l li,
  #r li {
    font-size: 1.2em !important;
  }
  .p {
    width: 19em;
  }
}
@media (min-width: 1024px) {
  .laser {
    flex-wrap: nowrap;
    justify-content: baseline;
    padding-bottom: 2em;
  }
  .laser_artist {
    flex-wrap: wrap;
    flex-direction: row;
    gap: 5em;
    margin-top: 5em;
  }
  .laser_artist_choose {
    flex-wrap: wrap;
    gap: 2em;
  }
  .laser_process {
    padding: 1em;
    font-size: 1em;
  }
  .laser_videos {
    flex-direction: row;
  }
  .laser_videos > video {
    width: 40em;
    height: 30em;
  }
  .laser_testimony {
    flex-direction: row;
  }
  .laser_testimony > video {
    width: 30em;
    height: 30em;
  }
  .card--1,
  .card--2,
  .card--3 {
    width: 15em;
    height: 30em;
  }
  .overlay-laser-menu {
    width: 50%;
    height: 50em;
  }
  #l li,
  #r li {
    font-size: 1.6em !important;
  }
  .p {
    width: 25em;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Laser-removal/Styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EAEA,QAAA;EAEA,2BAAA;EACA,UAAA;EACA,UAAA;EACA,mCAAA;AAHF;AAKE;EACE,2BAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,mDAAA;AAJJ;AAMI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAJN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AANJ;AAQI;EACE,WAAA;EACA,YAAA;AANN;AAUE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AARJ;AAUI;EACE,WAAA;EACA,YAAA;AARN;AAYE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,2CAAA;EACA,mDAAA;AAVJ;AAYI;EACE,cCjFK;ADuEX;AAaI;EACE,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,cCpFM;ADyEZ;AAcI;EACE,gBAAA;EACA,gBAAA;EACA,cC3FK;AD+EX;AAeI;EACE,gBAAA;EACA,gBAAA;EACA,cChGM;ADmFZ;AAgBI;EACE,gBAAA;EACA,gBAAA;EACA,cCvGK;ADyFX;AAiBI;EACE,gBAAA;EACA,gBAAA;EACA,cC5GM;AD6FZ;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EAEA,qJAAA;EAgBA,UAAA;AAlCF;AAoCE;EACE,gBAAA;AAlCJ;AAqCE;EACE,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAnCJ;AAsCE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AApCJ;AAqCI;EACE,UAAA;EACA,WAAA;AAnCN;AAsCI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AApCN;AAsCM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AApCR;AAsCM;EACE,gBAAA;EACA,cC5LG;ADwJX;AAwCI;EACE,0CAAA;AAtCN;AAuCM;EACE,YAAA;AArCR;AA0CE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAxCJ;AAyCI;EACE,UAAA;EACA,WAAA;AAvCN;AA0CI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AAxCN;AA0CM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAxCR;AA0CM;EACE,gBAAA;EACA,cCvOG;AD+LX;AA4CI;EACE,0CAAA;AA1CN;AA2CM;EACE,YAAA;AAzCR;AA8CE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA5CJ;AA6CI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AA3CN;AA8CI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AA5CN;AA8CM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AA5CR;AA8CM;EACE,gBAAA;EACA,cCpRG;ADwOX;AAgDI;EACE,0CAAA;AA9CN;AA+CM;EACE,YAAA;AA7CR;;AAmDA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AAhDF;;AAmDA;EACE;IACE,mBAAA;EAhDF;EAmDA;IACE,iBAAA;EAjDF;AACF;AAoDA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlDF;EAqDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnDF;EAqDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnDF;EAqDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnDF;EAqDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnDF;EAqDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnDF;EAqDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnDF;EAqDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnDF;EAqDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnDF;EAqDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnDF;AACF;AAsDA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApDF;EAuDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArDF;EAuDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArDF;EAuDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArDF;EAuDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArDF;EAuDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArDF;EAuDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArDF;EAuDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArDF;EAuDA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArDF;EAuDA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EArDF;EAwDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtDF;EAwDA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAtDF;EAyDA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvDF;EAyDA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAvDF;EA0DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxDF;EA0DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxDF;EA0DA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EAxDF;AACF;AA2DA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzDF;EA4DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1DF;EA4DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1DF;EA4DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1DF;EA4DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1DF;EA4DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1DF;EA4DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1DF;EA4DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1DF;EA4DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1DF;EA4DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1DF;EA4DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1DF;EA4DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1DF;AACF;AA6DA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA3DF;EA8DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5DF;EA8DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5DF;EA8DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5DF;EA8DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5DF;EA8DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5DF;EA8DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5DF;EA8DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5DF;EA8DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5DF;EA8DA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5DF;EA8DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5DF;EA8DA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5DF;AACF;AA+DA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA7DF;EAgEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9DF;EAgEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9DF;EAgEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9DF;EAgEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9DF;EAgEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9DF;EAgEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9DF;EAgEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9DF;EAgEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9DF;EAgEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA9DF;EAgEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9DF;EAgEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9DF;AACF;AAiEA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA/DF;EAkEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhEF;EAkEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhEF;EAkEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhEF;EAkEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhEF;EAkEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhEF;EAkEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhEF;EAkEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhEF;EAkEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhEF;EAkEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhEF;EAkEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhEF;EAkEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhEF;AACF;AAmEA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjEF;EAoEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlEF;EAoEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlEF;EAoEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlEF;EAoEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlEF;EAoEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlEF;EAoEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlEF;EAoEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlEF;EAoEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlEF;EAoEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlEF;EAoEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlEF;EAoEA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EAlEF;AACF;AAsEA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCC/wBU;AD2sBZ;;AAuEA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EAEA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AArEF;;AAuEA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AApEF;;AAsEA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAnEF;;AAqEA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAlEF;;AAoEA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAjEF;;AAmEA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAhEF;;AAkEA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AA/DF;;AAiEA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AA9DF;;AAgEA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AA7DF;;AAgEA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AA7DF;;AA+DA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AA5DF;;AA8DA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AA3DF;;AA8DA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA5DF;;AA8DA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AA3DF;;AA6DA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AA1DF;;AA4DA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAzDF;;AA2DA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAxDF;;AA0DA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAvDF;;AAyDA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAtDF;;AAyDA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAtDF;;AAwDA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AArDF;;AAwDA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AArDF;;AAuDA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AApDF;;AAuDA;;EAEE,kFAAA;AApDF;;AAuDA;;EAEE,kFAAA;AApDF;;AAuDA;;EAEE,kFAAA;AApDF;;AAuDA;;EAEE,iFAAA;AApDF;;AAuDA;;EAEE,sFAAA;AApDF;;AAuDA;;EAEE,+EAAA;AApDF;;AAuDA;EACE,WAAA;AApDF;;AAuDA;EACE,WAAA;EACA,sBAAA;EACA,aAAA;AApDF;;AAsDA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AAnDF;;AAsDA;EACE,YAAA;AAnDF;;AAsDA;EACE,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,4BAAA;EACA,6BAAA;AAnDF;;AAsDA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AAnDF;;AAsDA;EACE,6BAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,8CAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,MAAA;AAnDF;;AAqDA;EACE,kBAAA;EACA,qDAAA;EACA,yBChgCU;EDigCV,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,2BAAA;EACA,8CAAA;AAnDF;;AAqDA;EACE,iDAAA;EACA,0BAAA;EACA,uBAAA;AAlDF;;AAqDA;EACE,UAAA;EACA,yBChhCU;EDihCV,+BAAA;EACA,gCAAA;EACA,gBAAA;AAlDF;;AAqDA;EACE,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cC5hCS;ED6hCT,yBAAA;EACA,kBAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,cCtiCU;EDuiCV,yBAAA;EACA,kBAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,kCAAA;EACA,gBAAA;AAlDF;;AAqDA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AAlDF;;AAqDA;EACE,YAAA;AAlDF;;AAsDA;EAEE,6BAAA;EACA,kBAAA;AApDF;;AAuDA;EACE,UAAA;AApDF;;AE3gCE;EFmkCA;IACE,eAAA;IACA,YAAA;EApDF;EAsDE;IACE,QAAA;IACA,eAAA;EApDJ;EAsDI;IACE,eAAA;EApDN;EAuDI;IACE,UAAA;EArDN;EAyDE;IACE,YAAA;EAvDJ;EA0DE;IACE,sBAAA;EAxDJ;EAyDI;IACE,WAAA;IACA,YAAA;EAvDN;EA2DE;IACE,sBAAA;EAzDJ;EA0DI;IACE,WAAA;IACA,YAAA;EAxDN;EA6DA;IACE,WAAA;IACA,YAAA;EA3DF;EA8DA;;IAEE,2BAAA;EA5DF;EA+DA;IACE,2BAAA;EA7DF;EAiEA;IACE,WAAA;EA/DF;EAoEI;IACE,QAAA;EAlEN;AACF;AExjCE;EFgoCA;IACE,iBAAA;IACA,YAAA;IACA,yBAAA;EArEF;EAuEE;IACE,QAAA;IACA,eAAA;IACA,mBAAA;IACA,UAAA;IACA,SAAA;EArEJ;EAwEE;IACE,YAAA;IACA,gBAAA;EAtEJ;EAyEE;IACE,sBAAA;EAvEJ;EAwEI;IACE,WAAA;IACA,YAAA;EAtEN;EA0EE;IACE,sBAAA;EAxEJ;EAyEI;IACE,WAAA;IACA,YAAA;EAvEN;EA4EA;;;IAGE,WAAA;IACA,YAAA;EA1EF;EA6EA;IACE,UAAA;EA3EF;EA8EA;;IAEE,2BAAA;EA5EF;EA+EA;IACE,WAAA;EA7EF;AACF;AElmCE;EFmrCA;IACE,iBAAA;IACA,yBAAA;IACA,mBAAA;EA9EF;EAgFE;IACE,eAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;EA9EJ;EA+EI;IACE,eAAA;IACA,QAAA;EA7EN;EAiFE;IACE,YAAA;IACA,cAAA;EA/EJ;EAkFE;IACE,mBAAA;EAhFJ;EAiFI;IACE,WAAA;IACA,YAAA;EA/EN;EAmFE;IACE,mBAAA;EAjFJ;EAkFI;IACE,WAAA;IACA,YAAA;EAhFN;EAqFA;;;IAGE,WAAA;IACA,YAAA;EAnFF;EAsFA;IACE,UAAA;IACA,YAAA;EApFF;EAuFA;;IAEE,2BAAA;EArFF;EAwFA;IACE,WAAA;EAtFF;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n\n.laser {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  filter: blur(100px);\n  position: relative;\n  animation: blurry 2s ease-in-out forwards;\n\n  gap: 1em;\n\n  font-family: \"Varela Round\";\n  padding: 0;\n  z-index: 1;\n  transform: translate3d(0, 0, 0.1px);\n\n  &_title {\n    font-family: \"Varela Round\";\n    color: white;\n    padding: 0 3em;\n    margin: 0;\n  }\n\n  &_artist {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin: 5em;\n    padding: 0 0.2em;\n    animation: fadeIn 0.3s ease-in-out forwards;\n    transition: all 10s cubic-bezier(0.77, 0, 0.175, 1);\n\n    &_choose {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  &_videos {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    margin: 3em;\n    padding: 0 0.2em;\n    gap: 2em;\n\n    & > video {\n      width: 40em;\n      height: 30em;\n    }\n  }\n\n  &_testimony {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    margin: 1em;\n    padding: 0 0.2em;\n    gap: 2em;\n\n    & > video {\n      width: 30em;\n      height: 30em;\n    }\n  }\n\n  &_process {\n    height: 40em;\n    overflow-y: scroll;\n    color: white;\n    padding: 1em;\n    margin-top: 8em;\n    animation: fadeIn 0.3s ease-in-out forwards;\n    transition: all 10s cubic-bezier(0.77, 0, 0.175, 1);\n\n    & > h1 {\n      color: $bdt-gold;\n    }\n\n    &_content {\n      font-family: \"Varela Round\";\n      line-height: 2em;\n      font-size: 1.4em;\n      width: 80%;\n      color: $bdt-white;\n    }\n\n    &_steps > ol {\n      line-height: 2em;\n      font-size: 1.4em;\n      color: $bdt-gray;\n    }\n\n    &_steps > p {\n      line-height: 2em;\n      font-size: 1.4em;\n      color: $bdt-white;\n    }\n\n    &_technology {\n      line-height: 2em;\n      font-size: 1.4em;\n      color: $bdt-gray;\n    }\n\n    &_faq {\n      line-height: 2em;\n      font-size: 1.4em;\n      color: $bdt-white;\n    }\n  }\n}\n\n.overlay-laser-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n  //   margin-top: 6em;\n  width: 25%;\n  height: 50em;\n  opacity: 1;\n  position: relative;\n\n  background-image: linear-gradient(\n    to top,\n    #050505,\n    #1f1f1f,\n    #353536,\n    #4c4c4e,\n    #656567,\n    #656567,\n    #656567,\n    #656567,\n    #4c4c4e,\n    #353536,\n    #1f1f1f,\n    #050505\n  );\n\n  z-index: 5;\n\n  &_title {\n    margin-top: 10em;\n  }\n\n  &_subtitle {\n    font-family: \"Varela Round\";\n    font-size: 11px;\n    letter-spacing: 5px;\n    line-height: 2em;\n    color: white;\n    text-transform: uppercase;\n    position: relative;\n    padding: 1em 4em;\n  }\n\n  &_shirts {\n    cursor: pointer;\n    position: relative;\n    top: 20%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(136, 136, 138, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n    &_img {\n      width: 4em;\n      height: 4em;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n\n  &_tattoo-care {\n    cursor: pointer;\n    position: relative;\n    top: 22%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(136, 136, 138, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n    &_img {\n      width: 4em;\n      height: 4em;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n\n  &_jewelry {\n    cursor: pointer;\n    position: relative;\n    top: 24%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(136, 136, 138, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n    &_img {\n      width: 4em;\n      height: 4em;\n      border-radius: 4px;\n      overflow: hidden;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  object-position: center center;\n  object-fit: cover;\n  image-rendering: auto;\n}\n\n@keyframes blurry {\n  0% {\n    filter: blur(100px);\n  }\n\n  100% {\n    filter: blur(0px);\n  }\n}\n\n@keyframes flickerL {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  100% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n    // opacity: 1;\n  }\n}\n@keyframes flickerO {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.66667% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  73.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  74% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  74.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  75.33333% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  75.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  94.44444% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerA {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  88.86667% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  88.88889% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerD {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  83.31111% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  83.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerI {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  77.75556% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  77.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerN {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.2% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerG {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  66.64444% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  66.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n#l-mobile li, #r-mobile li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.4vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: $bdt-white;\n}\n\n#l {\n  position: absolute;\n  top: 20%;\n  left: 0%;\n  //   right: 0;\n  height: 5vw;\n  width: 40%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#l li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#l li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n#l li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n#l li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#l li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#l li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n#l li:nth-child(6) {\n  animation-name: flickerN;\n  animation-delay: 1.25s;\n  animation-duration: 4.5s;\n}\n#l li:nth-child(7) {\n  animation-name: flickerG;\n  animation-delay: 1.5s;\n  animation-duration: 4.5s;\n}\n\n#l li:nth-child(8) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#l li:nth-child(9) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#l li:nth-child(10) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n\n#r {\n  position: absolute;\n  top: 20%;\n  left: 30%;\n  // right: 0%;\n  height: 5vw;\n  width: 50%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#r li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#r li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n#r li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n#r li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#r li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#r li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n\n#r li:nth-child(6) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#r li:nth-child(7) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n\n#r li:nth-child(8) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#r li:nth-child(9) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n\n.card--laser1 .card__img,\n.card--laser1 .card__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/removal-1.png\");\n}\n\n.card--laser2 .card__img,\n.card--laser2 .card__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/removal-2.png\");\n}\n\n.card--laser3 .card__img,\n.card--laser3 .card__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/removal-3.png\");\n}\n\n.card--1 .card__img,\n.card--1 .card__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/q-artist.png\");\n}\n\n.card--2 .card__img,\n.card--2 .card__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/krissy-artist.png\");\n}\n\n.card--3 .card__img,\n.card--3 .card__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/miriam.png\");\n}\n\n.card__like {\n  width: 18px;\n}\n\n.card__clock {\n  width: 15px;\n  vertical-align: middle;\n  fill: #ad7d52;\n}\n.card__time {\n  font-size: 12px;\n  color: #ad7d52;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\n.card__clock-info {\n  float: right;\n}\n\n.card__img {\n  visibility: hidden;\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 235px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.card__info-hover {\n  position: absolute;\n  padding: 16px;\n  width: 100%;\n  opacity: 0;\n  top: 0;\n}\n\n.card__img--hover {\n  transition: 0.2s all ease-out;\n  background-size: cover;\n  background-repeat: no-repeat;\n  transform: translateY(-1px);\n  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n  width: 100%;\n  position: absolute;\n  height: 20em;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  top: 0;\n}\n.card {\n  margin-right: 25px;\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0, 1);\n  background-color: $bdt-black;\n  width: 25em;\n  height: 30em;\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n\n  transform: translateY(-1px);\n  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n}\n.card:hover {\n  box-shadow: 0px 30px 18px -8px rgba(0, 0, 0, 0.1);\n  transform: scale(1.1, 1.1);\n  border: 1px solid white;\n}\n\n.card__info {\n  z-index: 2;\n  background-color: $bdt-white;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  padding: 7em 1em;\n}\n\n.card__category {\n  display: inline-block;\n  font-family: \"Varela Round\";\n  font-size: 11px;\n  letter-spacing: 5px;\n  color: $bdt-gray;\n  text-transform: uppercase;\n  position: relative;\n}\n\n.card__title {\n  margin-top: 5px;\n  margin-bottom: 10px;\n  font-family: \"Varela Round\";\n  color: $bdt-black;\n  text-transform: uppercase;\n  position: relative;\n}\n\n.card__by {\n  font-size: 12px;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 500;\n}\n\n.card__author {\n  font-weight: 600;\n  text-decoration: none;\n  color: #ad7d52;\n}\n\n.card:hover .card__img--hover {\n  height: 100%;\n  //   opacity: 0.3;\n}\n\n.card:hover .card__info {\n  //   background-color: white;\n  background-color: transparent;\n  position: relative;\n}\n\n.card:hover .card__info-hover {\n  opacity: 1;\n}\n\n@include screen-sm {\n  .laser {\n    flex-wrap: wrap;\n    height: auto;\n\n    &_artist {\n      gap: 5em;\n      flex-wrap: wrap;\n\n      &_choose {\n        flex-wrap: wrap;\n      }\n\n      & article {\n        z-index: 4;\n      }\n    }\n\n    &_process {\n      padding: 2em;\n    }\n\n    &_videos {\n      flex-direction: column;\n      & > video {\n        width: 30em;\n        height: 30em;\n      }\n    }\n\n    &_testimony {\n      flex-direction: column;\n      & > video {\n        width: 30em;\n        height: 30em;\n      }\n    }\n  }\n\n  .overlay-laser-menu {\n    width: 100%;\n    height: 30em;\n  }\n\n  #l li,\n  #r li {\n    font-size: 1.2em !important;\n  }\n\n  #l-mobile li {\n    font-size: 1.8em !important;\n  \n  }\n\n  .card {\n    width: 20em;  \n  }\n\n  .laser {\n    &_artist {\n      &_choose {\n        gap: 5em;\n      }\n    }\n  }\n}\n\n@include screen-md {\n  .laser {\n    flex-wrap: nowrap;\n    height: auto;\n    justify-content: baseline;\n\n    &_artist {\n      gap: 0em;\n      margin-top: 8em;\n      flex-direction: row;\n      padding: 0;\n      margin: 0;\n    }\n\n    &_process {\n      padding: 1em;\n      font-size: 0.8em;\n    }\n\n    &_videos {\n      flex-direction: column;\n      & > video {\n        width: 30em;\n        height: 30em;\n      }\n    }\n\n    &_testimony {\n      flex-direction: column;\n      & > video {\n        width: 30em;\n        height: 30em;\n      }\n    }\n  }\n\n  .card--laser1,\n  .card--laser2,\n  .card--laser3 {\n    width: 20em;\n    height: 20em;\n  }\n\n  .overlay-piercing-menu {\n    width: 50%;\n  }\n\n  #l li,\n  #r li {\n    font-size: 1.2em !important;\n  }\n\n  .p {\n    width: 19em;\n  }\n}\n\n@include screen-lg {\n  .laser {\n    flex-wrap: nowrap;\n    justify-content: baseline;\n    padding-bottom: 2em;\n\n    &_artist {\n      flex-wrap: wrap;\n      flex-direction: row;\n      gap: 5em;\n      margin-top: 5em;\n      &_choose {\n        flex-wrap: wrap;\n        gap: 2em;\n      }\n    }\n\n    &_process {\n      padding: 1em;\n      font-size: 1em;\n    }\n\n    &_videos {\n      flex-direction: row;\n      & > video {\n        width: 40em;\n        height: 30em;\n      }\n    }\n\n    &_testimony {\n      flex-direction: row;\n      & > video {\n        width: 30em;\n        height: 30em;\n      }\n    }\n  }\n\n  .card--1,\n  .card--2,\n  .card--3 {\n    width: 15em;\n    height: 30em;\n  }\n\n  .overlay-laser-menu {\n    width: 50%;\n    height: 50em;\n  }\n\n  #l li,\n  #r li {\n    font-size: 1.6em !important;\n  }\n\n  .p {\n    width: 25em;\n  }\n}\n","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
